import axios from 'axios';

const REQUIRED_FIELDS = {
  supplierCif: 'NIF Proveedor',
  companyCif: 'NIF Cliente',
  dateOperation: 'Fecha emisión',
  lines: 'Líneas'
};

export const parseSpanishDate = (dateStr) => {
  if (!dateStr) return null;
  const parts = dateStr.trim().split('/');
  if (parts.length !== 3) return null;
  const [day, month, year] = parts.map(Number);
  if (!day || !month || !year) return null;
  return new Date(year, month - 1, day).getTime();
};

export const toNumber = (value) => {
  if (value == null) return 0;
  if (typeof value === 'number') return value;
  const cleaned = String(value).replace(/\./g, '').replace(',', '.');
  const num = parseFloat(cleaned);
  return isNaN(num) ? 0 : num;
};

export const transformInvoiceData = (data) => ({
  supplierCif: (data.proveedor?.nif || '').trim(),
  companyCif: (data.cliente?.nif || '').trim(),
  dateOperation: parseSpanishDate(data.documento?.fecha_emision),
  reference: (data.documento?.numero || '').trim(),
  lines: (data.lineas || []).map(line => ({
    concept: line.descripcion || '',
    quantity: toNumber(line.cantidad),
    unitPrice: toNumber(line.precio_unitario)
  }))
});

export const validatePurchaseInvoice = (payload) => {
  const missing = [];
  if (!payload.supplierCif) missing.push(REQUIRED_FIELDS.supplierCif);
  if (!payload.companyCif) missing.push(REQUIRED_FIELDS.companyCif);
  if (!payload.dateOperation) missing.push(REQUIRED_FIELDS.dateOperation);
  if (!payload.lines?.length) missing.push(REQUIRED_FIELDS.lines);
  return missing;
};

export const sendPurchaseInvoice = async (invoiceData, accessKey) => {
  const payload = transformInvoiceData(invoiceData);
  const errors = validatePurchaseInvoice(payload);
  if (errors.length > 0) throw new Error(`Campos obligatorios vacíos: ${errors.join(', ')}`);

  const response = await axios.post('/api/forward-purchase-invoice', { accessKey, payload });
  return response.data;
};

export const sendPurchaseInvoiceAttachment = async (file, invoiceHash, accessKey) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('accessKey', accessKey);
  formData.append('invoiceHash', invoiceHash);

  const response = await axios.post('/api/forward-purchase-invoice-attachment', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data;
};
